import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Listing } from 'ha/services/apiV2/types/Listing';
import { APIV2_URL } from './constants';

interface Query {
  expand?: string;
  withPhotos?: string;
  withCroppedPhotos?: boolean;
}

export default (makeCall: MakeCall) => (
  listingId: string | number,
  query?: Query,
) =>
  makeCall<Listing>('GET', `${APIV2_URL}/listing/${listingId}`, {
    query,
  });
